// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_i2ha5","lightboxWrap":"lightboxWrap_Mcv0e","imagesBig":"imagesBig_Y7zEP","imagesWrap":"imagesWrap_lAUzj"};